'use strict';

var cov_bxeyphako = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/filesDisplay/filesDisplay.js',
        hash = '6e5d7cd32e1da3792241aed505f92236066a8a62',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/filesDisplay/filesDisplay.js',
        statementMap: {
            '0': {
                start: {
                    line: 3,
                    column: 8
                },
                end: {
                    line: 3,
                    column: 37
                }
            },
            '1': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 16,
                    column: 9
                }
            },
            '2': {
                start: {
                    line: 12,
                    column: 22
                },
                end: {
                    line: 12,
                    column: 61
                }
            },
            '3': {
                start: {
                    line: 13,
                    column: 12
                },
                end: {
                    line: 15,
                    column: 13
                }
            },
            '4': {
                start: {
                    line: 14,
                    column: 16
                },
                end: {
                    line: 14,
                    column: 41
                }
            },
            '5': {
                start: {
                    line: 17,
                    column: 8
                },
                end: {
                    line: 17,
                    column: 18
                }
            },
            '6': {
                start: {
                    line: 21,
                    column: 0
                },
                end: {
                    line: 30,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 2,
                        column: 4
                    },
                    end: {
                        line: 2,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 2,
                        column: 28
                    },
                    end: {
                        line: 4,
                        column: 5
                    }
                },
                line: 2
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 6,
                        column: 4
                    },
                    end: {
                        line: 6,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 6,
                        column: 14
                    },
                    end: {
                        line: 8,
                        column: 5
                    }
                },
                line: 6
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 10,
                        column: 4
                    },
                    end: {
                        line: 10,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 20
                    },
                    end: {
                        line: 18,
                        column: 5
                    }
                },
                line: 10
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 11,
                        column: 8
                    },
                    end: {
                        line: 16,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 11,
                        column: 8
                    },
                    end: {
                        line: 16,
                        column: 9
                    }
                }, {
                    start: {
                        line: 11,
                        column: 8
                    },
                    end: {
                        line: 16,
                        column: 9
                    }
                }],
                line: 11
            },
            '1': {
                loc: {
                    start: {
                        line: 13,
                        column: 12
                    },
                    end: {
                        line: 15,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 13,
                        column: 12
                    },
                    end: {
                        line: 15,
                        column: 13
                    }
                }, {
                    start: {
                        line: 13,
                        column: 12
                    },
                    end: {
                        line: 15,
                        column: 13
                    }
                }],
                line: 13
            },
            '2': {
                loc: {
                    start: {
                        line: 13,
                        column: 16
                    },
                    end: {
                        line: 13,
                        column: 33
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 13,
                        column: 16
                    },
                    end: {
                        line: 13,
                        column: 17
                    }
                }, {
                    start: {
                        line: 13,
                        column: 21
                    },
                    end: {
                        line: 13,
                        column: 33
                    }
                }],
                line: 13
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0],
            '2': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FilesDisplayController = function () {
    function FilesDisplayController($rootScope) {
        _classCallCheck(this, FilesDisplayController);

        cov_bxeyphako.f[0]++;
        cov_bxeyphako.s[0]++;

        this.$rootScope = $rootScope;
    }

    _createClass(FilesDisplayController, [{
        key: '$onInit',
        value: function $onInit() {
            cov_bxeyphako.f[1]++;
        }
    }, {
        key: 'fileToName',
        value: function fileToName(url) {
            cov_bxeyphako.f[2]++;
            cov_bxeyphako.s[1]++;

            if (url) {
                cov_bxeyphako.b[0][0]++;

                var m = (cov_bxeyphako.s[2]++, url.toString().match(/.*\/(.+?)\.(.+)/));
                cov_bxeyphako.s[3]++;
                if ((cov_bxeyphako.b[2][0]++, m) && (cov_bxeyphako.b[2][1]++, m.length > 1)) {
                    cov_bxeyphako.b[1][0]++;
                    cov_bxeyphako.s[4]++;

                    return m[1] + '.' + m[2];
                } else {
                    cov_bxeyphako.b[1][1]++;
                }
            } else {
                cov_bxeyphako.b[0][1]++;
            }
            cov_bxeyphako.s[5]++;
            return "";
        }
    }]);

    return FilesDisplayController;
}();

cov_bxeyphako.s[6]++;


angular.module('app').component('filesDisplay', {
    templateUrl: 'app/components/filesDisplay/filesDisplay.html',
    controller: FilesDisplayController,
    bindings: {
        files: '=',
        deletable: '='
    }
});